module.exports = {
	"id": "KP",
	"name": "North Korea",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.017876,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 5.032094,
			"23": null,
			"24": null,
			"25": 0.062566,
			"26": 8.106766,
			"27": 0.143008,
			"28": 0.339644,
			"29": null,
			"30": 0.017876,
			"31": 0.294954,
			"32": 0.080442,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.017876,
			"38": null,
			"39": null,
			"40": 0.473714,
			"41": null,
			"42": null,
			"43": 0.160884,
			"44": 14.452746,
			"45": 0.795482,
			"46": 0.062566,
			"47": 0.49159,
			"48": 0.143008,
			"49": 5.058908,
			"50": 5.711382,
			"51": 1.108312,
			"52": 1.662468,
			"53": 13.657264,
			"54": 1.582026,
			"55": 0.017876,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": 0.017876,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.294954,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.035752,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.017876,
			"29": null,
			"30": null,
			"31": 0.214512,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.214512,
			"38": 0.277078,
			"39": 0.143008,
			"40": 0.455838,
			"41": null,
			"42": null,
			"43": 0.035752,
			"44": null,
			"45": 0.393272,
			"46": 0.062566,
			"47": 0.813358,
			"48": 3.610952,
			"49": 12.504262,
			"50": null,
			"51": 0.017876,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.035752,
			"38": null,
			"39": null,
			"40": 0.098318,
			"41": 0.017876,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.35752,
			"8": null,
			"9": 0.598846,
			"10": 0.35752,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": 0.53628
		},
		"ios_saf": {
			"8": 0,
			"10": 2.84366372523,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0766334469192,
			"8.1-8.4": 0.141577046003,
			"9.0-9.2": 0.0675413430475,
			"9.3": 1.0304384388
		},
		"android": {
			"3": 0,
			"4": 0.0464865116279,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00581081395349,
			"4.1": 0.167683488372,
			"4.2-4.3": 0.41920872093,
			"4.4": 0.961274651163,
			"4.4.3-4.4.4": 0.969575813953
		},
		"ie": {
			"6": 0.314934754839,
			"7": null,
			"8": 0.505804303226,
			"9": null,
			"10": 0.906630354839,
			"11": 4.17049963226,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0163321474201,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000453670761671
		},
		"edge": {
			"12": 0.035752,
			"13": 0.294954,
			"14": 0.598846
		},
		"ie_mob": {
			"10": 0.0533991549296,
			"11": 0.21741084507
		},
		"bb": {
			"7": 0.016992,
			"10": null
		},
		"samsung": {
			"0": 0.101952
		},
		"and_uc": {
			"0": 0.134874
		},
		"op_mini": {
			"0": 0.220040181818
		},
		"and_chr": {
			"0": 3.220684
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 98.1423370452
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KP.json
 ** module id = 566
 ** module chunks = 0
 **/